import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IntegradorModule } from './../../resources/modules/integrador.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './components/login/login.component';
import { TratamientosDatosComponent } from './components/condiciones/tratamiento-datos.component';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    IntegradorModule,
    FormsModule
  ],
  declarations: [
  	LoginComponent,
    TratamientosDatosComponent
  ],
  entryComponents: [
    TratamientosDatosComponent
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/login/login.module.ts